import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthForm from "../../components/authForm/AuthForm";
import Cookies from "js-cookie";
import { login } from "../../components/http";
import styles from "./Login.module.scss";

function Login() {
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (data) => {
    try {
      const response = await login(data);
      if (response.access_token) {
        Cookies.set("access_token", response.access_token, { expires: 7, secure: true });

        setMessage("Login successful");
        setIsSuccess(true);

        navigate("/dashboard");
      } else {
        setMessage("Login failed");
        setIsSuccess(false);
      }
    } catch (error) {
      setMessage("An error occurred during login");
      setIsSuccess(false);
    }
  };

  return (
    <div className={`${styles["login-container"]} dark`}>
      <div className={`${styles["login-box"]} dark`}>
        <AuthForm mode="Login" onSubmit={handleLogin} />
        {message && (
          <p
            className={`${styles.message} ${
              isSuccess ? styles.success : styles.error
            }`}
          >
            {message}
          </p>
        )}
        <p className={styles["signup-link"]}>
          <a href="/signup">Don't have an account? Signup</a>
        </p>
      </div>
    </div>
  );
}

export default Login;
